import { z } from 'zod';
import { pageOf } from '#src/common/pagination.contract.js';
/**
 * Empresas e estabelecimentos, como o ERP os informa. Os códigos são texto
 * mesmo quando o ERP usa números: o contrato não depende do sistema de origem.
 */
export const organizationCodeSchema = z
    .string()
    .trim()
    .min(1)
    .max(20)
    .regex(/^[\w.-]+$/, 'código inválido');
export const companySchema = z.strictObject({
    code: organizationCodeSchema,
    name: z.string(),
    legalName: z.string().nullable(),
});
export const establishmentSchema = z.strictObject({
    code: organizationCodeSchema,
    name: z.string(),
});
export const companyPageSchema = pageOf(companySchema);
export const establishmentPageSchema = pageOf(establishmentSchema);
//# sourceMappingURL=organization.contract.js.map